module.exports = __webpack_public_path__ + "img/logo.b02b1dc7.svg";